import styles from '../../../sass/components/buttons/borderless.module.scss'
import {Button} from "@/Components/Buttons/Button";

export function ButtonBorderless(props) {
    return (
        <Button
            className={`${props.className ?? ''} ${styles.borderless}`}
            dataQa={props.dataQa}
            dataTestid={props.dataTestid}
            size={props.size ?? 'md'}
            iconType={props.iconType ?? 'fas'}
            iconLeft={props.iconLeft ?? null}
            iconRight={props.iconRight ?? null}
            onClick={props.onClick ?? null}
            type={props.type ?? 'button'}
            href={props.href ?? null}
            disabled={props.disabled ?? false}
        >{props.children}</Button>
    )
}
